
import React from 'react';

const ProductFormLoading = () => {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      <p className="ml-2">Chargement...</p>
    </div>
  );
};

export default ProductFormLoading;
